'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var NavLink = require('../../components/NavLink.js');
require('./MobileNavbarList.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MobileNavbarList = function (props) {
    var menu = props.menu, isChildren = props.isChildren;
    return (React__default['default'].createElement("ul", { className: "mbl-root " + (isChildren ? 'mbl-child_root' : '') }, menu.map(function (item) { return (React__default['default'].createElement(MobileNavbarItem, { key: "mb-item-" + item.title, item: item, isChildren: isChildren })); })));
};
var MobileNavbarItem = function (props) {
    var item = props.item, isChildren = props.isChildren;
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var toggleOpen = function () {
        setIsOpen(!isOpen);
    };
    return (React__default['default'].createElement("li", { className: "mbl-list " + (isChildren ? 'child_list' : '') },
        React__default['default'].createElement(NavLink.NavLink, { item: item, isWithStyle: true }),
        item.childItems && (React__default['default'].createElement(React__default['default'].Fragment, null,
            React__default['default'].createElement("span", { onClick: toggleOpen, className: 'mbl-span' },
                React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--arrow-" + (isOpen ? 'up' : 'down') + "-small" })),
            isOpen && (React__default['default'].createElement(MobileNavbarList, { menu: item.childItems, isChildren: true }))))));
};

exports.MobileNavbarList = MobileNavbarList;
//# sourceMappingURL=MobileNavbarList.js.map
